const state = {
    BillOpState: '', //单据状态{View,New,Edit,Del}
    login: false, //是否登录
    browseRecord: [],
    isOpenRouter: true,
    isCloseRouter: '',
    recentListArr: [],//最近使用
    isCollapse: false,//侧边栏开关
    logoPic: 0,//自定义logo替换 counter
    token: '',//用户登录成功后当前用户的TOKENGUID存到状态管理器中
}
export default state;